import React, { Ref } from 'react'
import classNames from 'classnames'
import { FieldProps } from 'formik'
import './Input.less'
import { Box } from 'front-end/src/components'
import { css } from '@emotion/react'
import { useDebouncedCallback } from 'use-debounce'
import { formColors, brandColors } from 'shared/basicPalette'

type onChangeEventCallback = (
  val: string,
  event?: React.ChangeEvent<HTMLInputElement>
) => void

export type InputProps = {
  field?: FieldProps['field']
  fullWidth?: boolean
  light?: boolean
  onChange?: onChangeEventCallback
  debouncedOnChange?: onChangeEventCallback
  inputRef?: Ref<HTMLInputElement>
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>

/**
 * @deprecated
 * use Input from chakra instead
 * import { Input } from 'front-end/src/components'
 */
const Input = ({
  className,
  onChange,
  debouncedOnChange,
  value,
  type = 'text',
  fullWidth = false,
  light,
  inputRef,
  field,
  ...passThroughProps
}: InputProps) => {
  const debounced = useDebouncedCallback((e) => {
    debouncedOnChange && debouncedOnChange(e.target.value, e)
  }, 500)

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.preventDefault && e.preventDefault()
    const value = e.target.value
    e.persist()
    if (onChange) {
      onChange(value, e)
    }
  }

  const cssClasses = classNames('Input', { fullWidth }, className)

  const dynamicProps = {
    [onChange ? 'value' : 'defaultValue']: value
  }

  return (
    <Box
      w={fullWidth ? '100%' : 'auto'}
      css={css`
        input {
          background-color: ${light ? brandColors.white : formColors.bgColor};
          &:active,
          &:focus {
            border-color: var(--chakra-colors-buttonPrimary-500) !important;
          }
          &:hover {
            background-color: ${formColors.hoverBgColor} !important;
          }
        }
      `}
    >
      <input
        ref={inputRef}
        onChange={(e) => {
          onChangeInput(e)
          debouncedOnChange && debounced(e)
        }}
        type={type}
        className={cssClasses}
        {...dynamicProps}
        {...passThroughProps}
        {...field}
      />
    </Box>
  )
}

export default Input
